"use strict";
const router_1 = require("@angular/router");
const home_component_1 = require("./components/home/home.component");
const serviceLogin_component_1 = require("./components/serviceLogin/serviceLogin.component");
const plcviewer_component_1 = require("./components/plcviewer/plcviewer.component");
const scriptviewer_component_1 = require("./components/scriptviewer/scriptviewer.component");
const sqlviewer_component_1 = require("./components/sqlviewer/sqlviewer.component");
const configurationviewer_component_1 = require("./components/configurationviewer/configurationviewer.component");
const testpage_component_1 = require("./components/testpage/testpage.component");
const routes = [
    { path: '', component: home_component_1.HomeComponent },
    { path: 'home', component: home_component_1.HomeComponent },
    { path: 'login', component: serviceLogin_component_1.ServiceLoginComponent },
    { path: 'plcviewer', component: plcviewer_component_1.PlcViewerComponent },
    { path: 'scriptviewer', component: scriptviewer_component_1.ScriptViewerComponent },
    { path: 'sqlviewer', component: sqlviewer_component_1.SqlViewerComponent },
    { path: 'configuration', component: configurationviewer_component_1.ConfigurationViewerComponent },
    { path: 'testpage', component: testpage_component_1.TestPageComponent }
];
exports.APP_ROUTES = router_1.RouterModule.forRoot(routes);
